export default __webpack_public_path__ + "static/media/habilitar-permiso-camara-safari-2.ded16546.svg";